/**
 * Shared Mint Space window chrome surfaces (classic Mintly glass panels).
 * Compact density: dense lists, tight pads, small type.
 */

export const MINT_SPACE_SIDEBAR_WIDTH = "w-[248px]";

export function mintSpaceWindowCardClass(isDark) {
  return "border-separator-default bg-bg-raised text-label-primary";
}

export function mintSpaceSidebarSurfaceClass(isDark) {
  return "bg-bg-sidebar border-separator-default";
}

export function mintSpaceMainCanvasClass(isDark) {
  return "bg-transparent";
}

export function mintSpaceHairlineClass(isDark) {
  return "border-separator-default";
}

export function mintSpaceCardClass(isDark) {
  return isDark
    ? "mint-motion-lift border-white/10 bg-white/[0.04] hover:border-white/15 hover:bg-white/[0.06]"
    : "mint-motion-lift border-slate-200 bg-white hover:border-slate-300";
}

export function mintSpaceElevatedClass(isDark) {
  return "border-separator-default bg-bg-raised";
}

export function mintSpaceIconBtnClass(isDark) {
  return isDark
    ? "bg-black/50 hover:bg-black/70 text-white backdrop-blur-sm"
    : "bg-white/80 hover:bg-white text-slate-900 backdrop-blur-sm";
}

export function mintSpaceSectionLabelClass(isDark) {
  return "text-caps-group uppercase text-label-secondary";
}

export function mintSpaceMutedClass(isDark) {
  return "text-label-secondary";
}

export function mintSpaceBodyClass(isDark) {
  return "text-label-primary";
}

/** Outer pad for in-window pages */
export function mintSpacePagePadClass() {
  return "p-3 lg:p-4";
}

/** Page title row */
export function mintSpacePageTitleClass(isDark) {
  return "text-title-3 text-label-primary";
}

/** Dense card shell */
export function mintSpaceDenseCardClass(isDark) {
  return "rounded-radius-sm border border-separator-default bg-bg-raised p-3.5";
}
